<template>
  <div>
    <v-dialog
      v-model="showDialog"
      max-width="400"
    >
      <template v-slot:activator="{}">
        <v-btn
          text
          color="teal accent-4"
          fab
          small
          @click="openDialog"
        >
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <slot>
                <v-icon v-bind="attrs" v-on="on">
                  mdi-label
                </v-icon>
              </slot>
            </template>
            {{ actionVerb }} {{ label }}
          </v-tooltip>
        </v-btn>
      </template>

      <v-card>
        <v-card-title>{{ actionVerbCapitalized }} {{ label }} for {{ object[objectNameField] }}</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <DataList
                  :item-model.sync="value"
                  :type-object="listTypeObject"
                  :static-list="selectList"
                  :label="label"
                  clearable
                  dense
                  chips
                  small-chips
                  return-object
                  :multiple="multiple"
                  :item-text-function="itemTextFunction"
                >
                  <template v-slot:item="{ item }">
                    <TitleDashDescription
                      :title="item.name"
                      :description="descriptionField ? item[descriptionField] : '' "
                    />
                  </template>
                </DataList>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="cancel"
          >
            Cancel
          </v-btn>
          <v-btn
            @click="addItem(value)"
            color="blue darken-1"
            text
            :disabled="!value"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-chip
      v-for="value in values"
      :key="value.name"
      close
      @click:close="removeItem(value)"
      class="ma-0"
      dark
      small
    >
      {{ value.name }}
    </v-chip>
  </div>
</template>

<script>

import { mapActions } from 'vuex';
import TitleDashDescription from './microcomponents/TitleDashDescription.vue';
import DataList from './DataLists/DataList.vue';

export default {
  name: 'EditableList',
  components: {
    DataList,
    TitleDashDescription,
  },
  props: {
    label: {
      type: String,
      default() {
        return '';
      },
    },
    object: {
      type: Object,
      default() {
        return {};
      },
    },
    values: {
      type: Array,
      default() {
        return [];
      },
    },
    selectList: {
      type: Array,
      default() {
        return [];
      },
    },
    listTypeObject: {
      type: Object,
      default() {
        return {};
      },
    },
    objectNameField: {
      type: String,
      default: 'name',
    },
    descriptionField: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    itemTextFunction: {
      type: Function,
      default: (el) => el.name,
    },
    actionVerb: {
      type: String,
      default: 'add',
    },
  },
  data: () => ({
    showDialog: false,
    value: null,
  }),
  computed: {
    actionVerbCapitalized() {
      return this.actionVerb.charAt(0).toUpperCase() + this.actionVerb.slice(1);
    },
  },
  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),
    openDialog() {
      this.$emit('openDialog');
      this.showDialog = true;
      this.value = null;
    },
    cancel() {
      this.showDialog = false;
      this.value = null;
    },
    addItem() {
      this.$emit('addItem', this.object, this.value);
      this.showDialog = false;
    },
    removeItem(value) {
      this.$emit('removeItem', this.object, value);
    },
  },
};
</script>
